import { getAccountScopeUserSettings } from 'owa-session-store';
import { getFallbackValueIfNull } from 'owa-options-core';
import {
    type TeamsEmbedChatOptions,
    getOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-option-store';
import { lazyCreateOrUpdateOptionsForFeature } from 'owa-outlook-service-options';
import { type MailboxInfo } from 'owa-client-types';

export function getTeamsFeatureAvailabilityLastSession(mailboxInfo: MailboxInfo): boolean {
    const primeSettings = getAccountScopeUserSettings(mailboxInfo)?.PrimeSettings;
    const teamsFeatureAvailabilityStr = primeSettings?.Items?.find(
        item => item.Id === 'TeamsEmbedChatOptions'
    )?.Value?.options?.[0]?.teamsFeatureAvailability;

    try {
        return teamsFeatureAvailabilityStr && JSON.parse(teamsFeatureAvailabilityStr);
    } catch {
        // Handle JSON parsing error
        return false;
    }
}

export function setTeamsFeatureAvailabilityLastSession(
    isEnabled: boolean,
    mailboxInfo: MailboxInfo
): Promise<void> {
    const teamsEmbedChatOption = getFallbackValueIfNull(
        null,
        getOptionsForFeature<TeamsEmbedChatOptions>(OwsOptionsFeatureType.TeamsEmbedChat)
    );

    // Avoid updating server if the value is the same
    if (
        !!teamsEmbedChatOption?.teamsFeatureAvailability &&
        isMatching(isEnabled, teamsEmbedChatOption.teamsFeatureAvailability)
    ) {
        return Promise.resolve();
    }

    return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.TeamsEmbedChat,
        {
            ...teamsEmbedChatOption,
            teamsFeatureAvailability: JSON.stringify(isEnabled),
        } as TeamsEmbedChatOptions,
        mailboxInfo
    );
}

function isMatching(value: boolean, str: string): boolean {
    try {
        return value === JSON.parse(str);
    } catch {
        // Handle JSON parsing error
        return false;
    }
}
